import { Outlet } from 'react-router-dom';

import { OverviewSidebar } from '@/components/layout/Overview/OverviewSidebar';

export function OverviewLayout() {
  return (
    <div className="flex flex-1 min-w-0 overflow-hidden">
      <OverviewSidebar />
      <main className="flex-1 min-w-0 flex flex-col">
        <Outlet />
      </main>
    </div>
  );
}
